import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timespanFilter'
})
export class FormatTimespanValuePipe implements PipeTransform {
    public transform(timespan: string): string {
        if (typeof timespan === 'undefined' || timespan === null) {
            return '';
        }
        // group 2 - days, group 3 - time, group 6 - ms
        const matches = timespan.match('^(([0-9]+)\.)?(([0-9][0-9]:?){3})(\.([0-9]+))?$');
        if (matches.length > 0) {
            if (matches[2] === undefined) {
                return matches[3] === '00:00:00' ? `${matches[3]}${matches[6] ? '.' + matches[6] : ''}` : matches[3];
            } else {
                return `${matches[2]}d ${matches[3]}`;
            }
        }
        return '';
    }
}
